import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface MarketplaceSearchState {
    Search: string;
    Skill: string | undefined;
    Level: string | undefined;
    Industry: string | undefined;
    Jobtype: string | undefined;
    Worksite: string | undefined;
    Location: string | undefined;
    Result: any[];
}

const initialState: MarketplaceSearchState = {
    Search: "",
    Skill: undefined,
    Level: undefined,
    Industry: undefined,
    Jobtype: undefined,
    Worksite: undefined,
    Location: undefined,
    Result: []
}

export const marketplaceSearchSlice = createSlice({
    name: 'MarketplaceSearch',
    initialState,
    reducers: {
        setSearch(state, action: PayloadAction<MarketplaceSearchState["Search"]>){
            state.Search = action.payload
        },
        setSkill(state, action: PayloadAction<MarketplaceSearchState["Skill"]>){
            state.Skill = action.payload
        }, 
        setLevel(state, action: PayloadAction<MarketplaceSearchState["Level"]>){
            state.Level = action.payload
        }, 
        setIndustry(state, action: PayloadAction<MarketplaceSearchState["Industry"]>){
            state.Industry = action.payload
        }, 
        setJobType(state, action: PayloadAction<MarketplaceSearchState["Jobtype"]>){
            state.Jobtype = action.payload
        }, 
        setWorkSite(state, action: PayloadAction<MarketplaceSearchState["Worksite"]>){
            state.Worksite = action.payload
        },  
        setResult(state, action: PayloadAction<MarketplaceSearchState["Result"]>){
            state.Result = action.payload
        },  
        setLocation(state, action: PayloadAction<MarketplaceSearchState["Location"]>){
            state.Location = action.payload
        },  
    }
})

export const {
    setSearch,
    setSkill,
    setLevel,
    setIndustry,
    setJobType,
    setWorkSite,
    setResult,
    setLocation
} = marketplaceSearchSlice.actions

export default marketplaceSearchSlice.reducer

